// extracted by mini-css-extract-plugin
export default {"cardHeader":"cardHeader---sVFXh","layout":"layout---oukZ5"};